const ophanRemoteHost = window?.ophanRemoteHost || 'https://ophan.theguardian.com';
/**
 * Generates a unique page view ID.
 * @returns {string}
 */
const generatePageViewId = () => {
    return `${new Date().getTime().toString(36)}${'xxxxxxxxxxxx'.replace(/x/g, () => Math.floor(Math.random() * 36).toString(36))}`;
};
// Guardian Frontend Project pre-generates the pageViewId
let viewId;
if (typeof guardian !== 'undefined') {
    viewId = guardian.config?.ophan?.pageViewId ?? generatePageViewId();
}
else {
    viewId = generatePageViewId();
}
const bumpViewId = () => {
    viewId = generatePageViewId();
};
/**
 * Sends the initial event associated with this page view.
 * @param {Record<string, any>} obj - The data to be sent.
 */
const sendInitial = (obj) => {
    send(`${ophanRemoteHost}/img/1?${buildQueryString(obj)}`);
};
/**
 * Encodes a value for URL transmission.
 * @param {string | number} value - The value to encode.
 * @returns {string} The encoded value.
 */
const smartEncode = (value) => {
    if (typeof value === 'string' || typeof value === 'number') {
        return encodeURIComponent(value);
    }
    else {
        return encodeURIComponent(JSON.stringify(value));
    }
};
/**
 * Used for sending additional events after the initial PageView event.
 * @param {EventPayload} obj - The data object to be sent.
 * @param {Function} [f] - An optional callback function.
 */
const sendMore = (obj, f) => {
    if (!JSON)
        return;
    const values = [];
    for (const prop in obj) {
        // @ts-ignore
        if (obj.hasOwnProperty(prop) && isDefined(obj[prop])) {
            // @ts-ignore
            values.push(`${encodeURIComponent(prop)}=${smartEncode(obj[prop])}`);
        }
    }
    if (values.length === 0) {
        return;
    }
    const url = `${ophanRemoteHost}/img/2?viewId=${viewId}&${values.join('&')}`;
    send(url, f);
};
/**
 * Checks if a value is defined and not null.
 * @param {*} v - The value to check.
 * @returns {boolean} True if the value is defined, false otherwise.
 */
const isDefined = (v) => {
    if (Array.isArray(v)) {
        return !!v.length;
    }
    else {
        return v != null;
    }
};
/**
 * Builds a query string from an object.
 * @param {Record<string, any>} obj - The object to convert to a query string.
 * @returns {string} The resulting query string.
 */
const buildQueryString = (obj) => {
    obj.viewId = viewId;
    const values = [];
    for (const prop in obj) {
        if (obj.hasOwnProperty(prop) && obj[prop] != null) {
            values.push(`${encodeURIComponent(prop)}=${encodeURIComponent(obj[prop])}`);
        }
    }
    return values.join('&');
};
/**
 * Sends data to a specified URL.
 * @param {string} url - The URL to send data to.
 * @param {() => void} [f] - An optional callback function.
 */
const send = (url, f) => {
    if (typeof fetch === 'function') {
        fetch(url, {
            method: 'GET',
            mode: 'no-cors',
            keepalive: true,
            credentials: 'include',
        }).then(() => f?.());
    }
    else {
        const image = new Image();
        const checker = setInterval(() => {
            if (image.complete) {
                if (typeof f === 'function') {
                    f();
                }
                clearInterval(checker);
            }
        }, 10);
        image.src = url;
    }
};
export default {
    sendInitial,
    sendMore,
    viewId,
    bumpViewId,
};
/**
 * Exports for testing purposes.
 */
export const _testExports = {
    generatePageViewId,
    smartEncode,
    isDefined,
    buildQueryString,
};
